export enum ViewMode {
    Basic = "Basic",
    Extended = "Extended",
}
